module.exports = __webpack_public_path__ + "img/DE.3e726c2b.svg";